import { TextField } from "@mui/material";
import { Button, Col, Container, Row } from "react-bootstrap";
import MainBoldFont from "../../fonts/Google_Sans_Code/static/GoogleSansCode-Bold.ttf";
import { isMobile } from "react-device-detect";

const Cancellation: React.FC = () => {
  return (
    <Container
      style={{
        minHeight: "80vh",
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
      }}
    >
      <Row>
        <Col lg={6} md={6} sm={12} style={{ background: "transparent" }}>
          <h3
            style={{
              padding: 1,
              display: "flex",
              flexFlow: "row",
              fontFamily: MainBoldFont,
              font: MainBoldFont,
            }}
          ></h3>
          <h1
            className="player"
            style={{
              background: "tomato",
              width: "100%",
              color: "whitesmoke",
              fontFamily: MainBoldFont,
              font: MainBoldFont,
              fontSize: isMobile ? 20 : 100,
            }}
          >
            Wish to have your data deleted? We are here to help.
          </h1>
        </Col>
        <Col lg={6} md={6} sm={12} style={{ background: "yellow" }}>
          <TextField
            id="filled-basic"
            label="Email or Phone number"
            variant="filled"
          />
          <Button onClick={() => {}}></Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Cancellation;
